import { applyDecorators, Get, Type } from '@nestjs/common';
import { ApiForbiddenResponse, ApiInternalServerErrorResponse, ApiOkResponse, ApiUnauthorizedResponse, ApiUnprocessableEntityResponse } from '@nestjs/swagger';

import { Roles } from '../../auth';

export const ListResponse = <T extends Type>(path: string | string[], type?: [T], roles?: string[]) =>
  applyDecorators(
    ApiForbiddenResponse({ description: 'Forbidden (403)' }),
    ApiInternalServerErrorResponse({ description: 'Internal Server Error (500)' }),
    ApiOkResponse({ description: 'OK (200)', type }),
    ApiUnauthorizedResponse({ description: 'Unauthorized (401)' }),
    ApiUnprocessableEntityResponse({ description: 'Unprocessable Entity (422)' }),
    Get(path),
    Roles(roles)
  );
